import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

export const PillarCard = ({
  to,
  kicker,
  title,
  desc,
  Icon,
  className = "",
  feature = false,
  image = null,
  imageAlt = "",
  testid,
}) => {
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`group relative block bg-white border border-[#e5e5e5] hover:border-[#0a0a0a] transition-all duration-300 overflow-hidden ${className}`}
    >
      {feature && (
        <div className="absolute top-0 right-0 px-3 py-1 bg-[#0A4DFF] text-white text-[10px] font-mono tracking-widest z-10">
          PRIMARY
        </div>
      )}

      {feature && image ? (
        <div className="flex flex-col h-full">
          <div className="relative h-[55%] overflow-hidden bg-[#0a0a0a]">
            <img
              src={image}
              alt={imageAlt || title}
              className="w-full h-full object-cover opacity-95 transition-transform duration-700 ease-out group-hover:scale-[1.04]"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none" />
            <div className="absolute top-5 left-5 right-5 flex items-center justify-between font-mono text-[10px] tracking-widest text-white/80">
              <span>{kicker} · LIVE</span>
              <span className="w-2 h-2 rounded-full bg-[#0A4DFF] animate-pulse" />
            </div>
          </div>
          <div className="p-8 md:p-10 flex flex-col gap-5 grow">
            <div className="flex items-start justify-between">
              <span className="font-mono text-xs tracking-widest text-[#525252]">{kicker}</span>
              {Icon ? (
                <Icon size={28} weight="thin" className="text-[#0a0a0a] group-hover:text-[#0A4DFF] transition-colors" />
              ) : null}
            </div>
            <div className="mt-auto">
              <h3 className="font-display tracking-tight text-2xl md:text-3xl leading-[1.05] min-h-[2.2em]">
                {title}
              </h3>
              <p className="text-sm text-[#525252] mt-3 leading-relaxed min-h-[3em]">{desc}</p>
              <div className="mt-6 flex items-center gap-2 text-xs font-mono tracking-widest text-[#0a0a0a] group-hover:text-[#0A4DFF] transition-colors">
                <span>OPEN</span>
                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="p-8 md:p-10 h-full flex flex-col gap-6">
          <div className="flex items-start justify-between">
            <span className="font-mono text-xs tracking-widest text-[#525252]">{kicker}</span>
            {Icon ? (
              <Icon size={28} weight="thin" className="text-[#0a0a0a] group-hover:text-[#0A4DFF] transition-colors" />
            ) : null}
          </div>
          <div className="mt-auto">
            <h3 className="font-display tracking-tight text-xl md:text-2xl leading-[1.05] min-h-[2.4em]">
              {title}
            </h3>
            <p className="text-sm text-[#525252] mt-3 leading-relaxed min-h-[3em]">{desc}</p>
            <div className="mt-6 flex items-center gap-2 text-xs font-mono tracking-widest text-[#0a0a0a] group-hover:text-[#0A4DFF] transition-colors">
              <span>OPEN</span>
              <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </div>
          </div>
        </div>
      )}
    </Link>
  );
};

export default PillarCard;
